<mat-form-field [subscriptSizing]="'dynamic'" class="fuse-mat-dense min-w-36 w-full">
  <mat-label>{{label}}</mat-label>
  <mat-chip-grid #chipGridTeams>
    <mat-chip-row *ngFor="let team of teamsFC.value" (removed)="removeTeam(team.id)">
      {{team.name}}
      <mat-icon class="icon-size-5" matChipRemove>cancel</mat-icon>
    </mat-chip-row>
    <input #teamsSearchInput [placeholder]="'Search...'" [matChipInputFor]="chipGridTeams"
      [matAutocomplete]="autoTeams" [formControl]="teamsSearchFC" [matChipInputAddOnBlur]="true">
    <mat-autocomplete autoActiveFirstOption #autoTeams="matAutocomplete" (optionSelected)="selectedTeams($event)" [displayWith]="displayWith">
      <mat-option [value]="team" *ngFor="let team of teams$ | async">{{team.name}}</mat-option>
    </mat-autocomplete>
  </mat-chip-grid>
  <button *ngIf="teamsFC.value.length > 0" mat-icon-button matSuffix (click)="removeTeams()" [matTooltip]="'Clear all'">
    <mat-icon svgIcon="mat_outline:clear_all"></mat-icon>
  </button>
  <!-- <div class="text-red-500 text-xs" *ngIf="teamsFC.touched && teamsFC.hasError('required')">Teams is required</div> -->
</mat-form-field>